import React from 'react';
import BaseIcon from './BaseIcon';


const PrepareToSendIcon = props => (
  <BaseIcon {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path d="M6.9672697,10.7536446 L9.84797271,7.20816395 C10.1013272,6.89634297 10.0779648,6.44346427 9.79386903,6.15936847 C9.50977324,5.87527268 9.05689453,5.85191026 8.74507356,6.10526479 L5.1372854,9.03659267 L0.76308561,6.68125432 C0.656563408,6.62389621 0.574450967,6.52986059 0.531970933,6.41658049 C0.435010872,6.15802033 0.566013638,5.86981425 0.824573801,5.77285418 L14.8006238,0.531835422 C14.9093612,0.491058924 15.0289014,0.489404705 15.1387254,0.527156711 C15.3998696,0.61692501 15.5387972,0.901395751 15.4490289,1.16253989 L10.6378964,15.1585614 C10.6002461,15.2680897 10.5257399,15.3611504 10.4271019,15.4218507 C10.1919229,15.5665762 9.8839495,15.4932492 9.73922399,15.2580703 L6.9672697,10.7536446 Z" fillRule="nonzero" />
    </g>
  </BaseIcon>
);

export default PrepareToSendIcon;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Icons/PrepareToSendIcon.jsx